module.exports = {
    recipe: {
        disclaimerMessageUnavailableProducts:
            'Please note that recipe ingredients are subject to availability. While every effort is made to ensure recipe ingredients are available to “add to cart”, if any product is showing as unavailable you can use the search bar at the top of this page to find alternative ingredients in your location.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/recipe.js